<template>
  <div class="index">
    <div class="nav1">
      <div class="tit1">岗位分析提示词</div>
    </div>
    <div class="nav2">
      <div class="myForm">
        <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
          <el-tab-pane
            v-for="(item, index) in promptList"
            :key="index"
            :label="'提示词 ' + (index + 1)"
            :name="index.toString()">
            <el-input
              type="textarea"
              :rows="30"
              placeholder="请输入岗位分析提示词"
              v-model="promptList[index]">
            </el-input>
          </el-tab-pane>
          <el-tab-pane name="add">
            <template slot="label">
              <i class="el-icon-plus"></i>
            </template>
          </el-tab-pane>
        </el-tabs>
        <div class="button-container">
          <el-button style="margin-top:10px" icon="el-icon-s-promotion" size="small" type="primary" @click="submitForm">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: "0",
      promptList: [""],
      originalPromptList: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const res = await this.$api.crudselectonebyid({
        table: 'systems',
        id: 1,
        columns: 'prompt_post'
      });
      if (res.data && res.data.data && res.data.data.prompt_post) {
        try {
          this.promptList = JSON.parse(res.data.data.prompt_post);
          this.originalPromptList = [...this.promptList];
          if (this.promptList.length === 0) {
            this.promptList = [""];
          }
        } catch (e) {
          console.error('Failed to parse prompt_post:', e);
          this.promptList = [""];
        }
      } else {
        this.promptList = [""];
      }
    },
    handleTabClick(tab) {
      if (tab.name === 'add') {
        this.promptList.push("");
        this.activeTab = (this.promptList.length - 1).toString();
      }
    },
    // 提交
    async submitForm() {
      // Filter out empty prompts
      const nonEmptyPrompts = this.promptList.filter(prompt => prompt.trim() !== "");
      
      if (nonEmptyPrompts.length === 0) {
        this.$message.warning('至少需要保留一个提示词');
        return;
      }

      const res = await this.$api.crudupdatebyid({
        table: 'systems',
        id: 1,
        values: {
          prompt_post: JSON.stringify(nonEmptyPrompts)
        }
      });
      
      if (res.data && res.data.result == 1) {
        this.$message({
          message: res.data.msg || '保存成功',
          type: "success"
        });
        this.getData();
      } else {
        this.$message.error(res.data ? res.data.msg : '保存失败');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.index {}

.nav1 {
  margin: 0 -18px;
  background-color: #fff;
  padding: 20px 32px 0 40px;

  .tit1 {
    color: #17233d;
    font-weight: 500;
    font-size: 20px;
    padding-bottom: 20px;
  }
}

.nav2 {
  margin: 18px 0;
  background: #fff;
  border-radius: 6px;
  padding: 24px;

  .myForm {
    ::v-deep .el-form-item__label {
      font-size: 12px;
    }

    ::v-deep .el-form-item {
      margin-right: 30px;
      margin-bottom: 20px;
    }

    ::v-deep .el-tabs__item {
      height: 40px;
      line-height: 40px;
    }

    ::v-deep .el-tabs__content {
      padding: 20px 0;
    }
  }
}

.button-container {
  margin-top: 20px;
  text-align: center;
}
</style> 